import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/app/legal/[slug]/LegalViewer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/app/mainNav.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@16.2.3_@babel+core@7.29.0_@opentelemetry+api@1.9.0_react-dom@19.2.1_react@19.2.1__react@19.2.1_sass@1.90.0/node_modules/next/dist/client/image-component.js");
